<template>
  <div class="content-wrapper">
    <!-- Page Loader -->
    <div class="vld-parent">
      <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    </div>

    <breadcrumb :page="$t('transcript.yearTranscript')"></breadcrumb>

    <div class="content">
      <div class="container-fluid">
        <back-button></back-button>

        <hr />

        <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{
          alertMessage
        }}</b-alert>

        <div class="row">
          <div class="col-10 mx-auto">
            <download-transcript
              :id="$route.params.id"
              type="year"
              v-if="downloadBtns"
            >
            </download-transcript>

            <div
              class="card"
              style="
                max-width: 820px;
                min-height: 760px;
                margin: 15px auto;
                padding: 100px 40px;
              "
              v-for="(page, academicYear) in pages"
              :key="academicYear"
            >
              <div class="card-body">
                <top
                  :student="student"
                  :program="program"
                  :report_date="report_date"
                  :academic_year="academicYear"
                ></top>

                <div
                  v-for="(academicYear2, semester) in page"
                  class="mb-3"
                  :key="semester"
                >
                  <h4 v-if="semester">
                    {{ semester }}.
                    {{
                      ["BBA", "AAE", "DBA"].includes(program.program_code)
                        ? $t("transcript.semester")
                        : $t("transcript.term")
                    }}
                  </h4>

                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th width="80px">{{ $t("transcript.code") }}</th>
                          <th width="300px">{{ $t("transcript.course") }}</th>
                          <th width="100px">
                            {{ $t("transcript.percentage") }}
                          </th>
                          <th width="80px">{{ $t("transcript.grade") }}</th>
                          <th width="80px" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                            {{ $t("transcript.sbsCredits") }}
                          </th>
                          <th width="100px" v-else>
                            {{ $t("transcript.ectsCredits") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(course, index) in courses[semester]"
                          v-bind:key="index"
                        >
                          <td>{{ course.course_code }}</td>
                          <td>{{ course.course_title }}</td>
                          <td class="text-center">{{ course.percentage }}</td>
                          <td align="left" style="padding-left: 4%">
                            {{ course.descriptive_grade }}
                          </td>
                          <td
                            class="text-center"
                            v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'"
                          >
                            {{ course.sbs_credits }}
                          </td>
                          <td class="text-center" v-else>
                            {{ course.ects_credits }}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colspan="3">
                            {{
                              $t("transcript.gradePointAverage", {
                                gpa:
                                  gpa[semester] !== undefined
                                    ? gpa[semester].gpa
                                    : 0,
                              })
                            }}
                          </th>
                          <th
                            colspan="2"
                            style="
                              min-width: 100px;
                              padding-right: 45px;
                              text-align: right;
                            "
                            v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'"
                          >
                            {{ $t("transcript.total") }}
                            <span class="font-weight-normal">
                              {{
                                gpa[semester] !== undefined
                                  ? gpa[semester].sbs_credits
                                  : 0
                              }}</span
                            >
                          </th>
                          <th
                            colspan="2"
                            style="
                              min-width: 100px;
                              padding-right: 45px;
                              text-align: right;
                            "
                            v-else
                          >
                            {{ $t("transcript.total") }}
                            <span class="font-weight-normal">
                              {{
                                gpa[semester] !== undefined
                                  ? gpa[semester].ects_credits
                                  : 0
                              }}</span
                            >
                          </th>
                        </tr>

                        <tr v-if="semester == semesters">
                          <th colspan="3">
                            {{
                              $t("transcript.cumulativeGPA", {
                                gpa: gpa[0] !== undefined ? gpa[0].gpa : 0,
                              })
                            }}
                          </th>
                          <th
                            colspan="2"
                            style="
                              min-width: 100px;
                              padding-right: 45px;
                              text-align: right;
                            "
                            v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'"
                          >
                            {{ $t("transcript.totalSBS") }}
                            <span class="font-weight-normal">
                              {{
                                gpa[0] !== undefined ? gpa[0].sbs_credits : 0
                              }}</span
                            >
                          </th>
                          <th
                            colspan="2"
                            style="
                              min-width: 100px;
                              padding-right: 45px;
                              text-align: right;
                            "
                            v-else
                          >
                            {{ $t("transcript.totalECTS") }}
                            <span class="font-weight-normal">
                              {{
                                gpa[0] !== undefined ? gpa[0].ects_credits : 0
                              }}</span
                            >
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>

                  <template v-if="semester == semesters">
                    <bottom
                      :student="student"
                      :program="program"
                      :registrar="registrar"
                    ></bottom>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DownloadTranscript from "../../components/DownloadTranscript";
import Top from "./_top";
import Bottom from "./_bottom";

export default {
  props: ["permissions", "dateFormat"],
  components: {
    DownloadTranscript,
    Top,
    Bottom,
  },

  data() {
    return {
      alert: false,
      alertClass: "",
      alertMessage: "",

      isLoading: false,
      fullPage: true,
      downloadBtns: false,

      program: {
        id: null,
        title: null,
        code: null,
        type: null,
        academic_year: null,
      },

      student: {
        id: null,
        student_number: null,
        name: null,
        birth_date: null,
        birth_place: null,
        partner_campus_location: null,
        report_date: null,
      },

      courses: [],
      secondary_courses: [],
      pages: [],

      report_date: null,
      registrar: null,
      semesters: null,
    };
  },

  mounted() {
    if (!this.permissions.viewStudentsTranscripts) {
      return this.$router.push("/");
    }

    this.fetch();
  },

  methods: {
    fetch() {
      this.isLoading = true;

      axios
        .get(`/api/transcripts/${this.$route.params.id}/year`)
        .then((response) => {
          let data = response.data;

          this.program = data.program;
          this.student = data.student;
          this.courses = data.courses;
          // this.secondary_courses = data.secondary_courses;
          this.pages = data.pages;
          this.semesters = data.semesters;
          this.registrar = data.registrar;
          this.report_date = data.report_date;

          // this.sbs_credits = data.sbs_credits;
          // this.ects_credits = data.ects_credits;
          // this.grades_points = data.grades_points;
          this.gpa = data.gpa; // term wise GPAs array

          if (this.pages.length == 0) {
            this.showAlert(this.$t("transcript.notFound"), "info");
          } else {
            this.downloadBtns = true;
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("error fetching transcript record");

          this.isLoading = false;
        });
    },

    /**
     * Show alert on the page
     *
     * @param string message
     * @param string class
     */
    showAlert(msg, cls = "success") {
      this.alertMessage = msg;
      this.alertClass = cls;
      this.alert = true;
    },
  },
};
</script>


<style lang="scss" scoped>
.content table#student-detials-table th,
.content table#student-detials-table td {
  border: 0;
}
</style>
